export const power_up_layout = {
  // Navigation
  home: "HOME",
  ai: "POWERING AI",
  about_us: "ABOUT",
  why_us: "WHY US?",
  contact_us: "CONTACT US",
  marketplace: "MARKETPLACE",

  // Logged In Navigation
  parts_inventory_home: "MARKETPLACE",
  my_portal: "MY PORTAL",
  my_listings: "MY LISTINGS",
  credit_balance: "CREDIT BALANCE",
  use_credits: "USE CREDITS",
  account: "ACCOUNT",
  support: "SUPPORT",
  admin_console: "ADMIN",
  sign_out: "SIGN OUT",
  account_menu_aria: "Account menu",
  logout: "LOGOUT",
  sell_a_part: "Sell a Part",

  // Footer
  footer_description: "More power. More uptime.",
  sign_up: "Sign Up",
  about_us_footer: "About Us",
  why_us_footer: "Why Us?",
  contact_us_footer: "Contact Us",
  copyright: "© { year } All rights reserved",
  company_name: "Scrap Gators",

  // Alt text
  logo_alt: "Power Asset Exchange Logo",
} as const;
